module.exports = __webpack_public_path__ + "img/1.31899675.png";